import React from 'react';

import { ILinkFields } from '../../../../../types/contentful';

import Link from '../../../Link';

export function FooterNavigationLink({
  title,
  url,
  openInNewTab,
  hasAffiliateLink
}: ILinkFields) {
  const path = url ?? '';
  return (
    <li>
      <Link
        href={hasAffiliateLink ? `/affiliates${path}` : path}
        target={openInNewTab ? '_blank' : ''}
        rel="noopener noreferrer"
        className="typography-body-1 font-normal text-on-screen-surface-dark no-underline transition-colors duration-200 hover:text-[#00D9B4] hover:underline"
      >
        {title}
      </Link>
    </li>
  );
}
